module.exports = __webpack_public_path__ + "static/media/booked.07deb7f7.svg";